module.exports = __webpack_public_path__ + "img/logo.c861a13c.png";